export const VIN_WONDER_TICKET_LIST_ACTION = "VIN_WONDER_TICKET_LIST_ACTION";
export const VIN_WONDER_TICKET_LIST_SUCCESS = "VIN_WONDER_TICKET_LIST_SUCCESS";
export const VIN_WONDER_TICKET_LIST_FAIL = "VIN_WONDER_TICKET_LIST_FAIL";
export const VIN_WONDER_TICKET_DELETE_TRANSLATE_SUCCESS = "VIN_WONDER_TICKET_DELETE_TRANSLATE_SUCCESS";

export const VIN_WONDER_TICKET_DETAIL_ACTION = "VIN_WONDER_TICKET_DETAIL_ACTION";
export const VIN_WONDER_TICKET_DETAIL_DELETE_ACTION = "VIN_WONDER_TICKET_DETAIL_DELETE_ACTION";
export const VIN_WONDER_TICKET_DETAIL_SUCCESS = "VIN_WONDER_TICKET_DETAIL_SUCCESS";
export const VIN_WONDER_TICKET_DETAIL_FAIL = "VIN_WONDER_TICKET_DETAIL_FAIL"

export const VIN_WONDER_TICKET_DETAIL_UPDATE_ACTION = "VIN_WONDER_TICKET_DETAIL_UPDATE_ACTION";
export const VIN_WONDER_TICKET_DETAIL_CREATE_ACTION = "VIN_WONDER_TICKET_DETAIL_CREATE_ACTION";

export const VIN_WONDER_TICKET_CREATE_TRANSLATE_ACTION = "VIN_WONDER_TICKET_CREATE_TRANSLATE_ACTION";
export const VIN_WONDER_TICKET_UPDATE_TRANSLATE_ACTION = "VIN_WONDER_TICKET_UPDATE_TRANSLATE_ACTION";
export const VIN_WONDER_TICKET_DELETE_TRANSLATE_ACTION = "VIN_WONDER_TICKET_DELETE_TRANSLATE_ACTION";

export const VIN_WONDER_TICKET_CREATE_TRANSLATE_SUCCESS = "CATEGORY_CREATE_TRANSLATE_SUCCESS";
export const VIN_WONDER_TICKET_UPDATE_TRANSLATE_SUCCESS = "VIN_WONDER_TICKET_UPDATE_TRANSLATE_SUCCESS";
export const VIN_WONDER_TICKET_FAIL = "VIN_WONDER_TICKET_FAIL";


// Ticket Item
export const VIN_WONDER_GET_ALL_REF = "VIN_WONDER_GET_ALL_REF";
export const VIN_WONDER_GET_ALL_REF_SUCCESS = "VIN_WONDER_GET_ALL_REF_SUCCESS";
export const VIN_WONDER_GET_ALL_REF_FAIL = "VIN_WONDER_GET_ALL_REF_FAIL";

export const VIN_WONDER_TICKET_ITEM_DETAIL_ACTION = "VIN_WONDER_TICKET_ITEM_DETAIL_ACTION";
export const VIN_WONDER_TICKET_ITEM_DETAIL_DELETE_ACTION = "VIN_WONDER_TICKET_ITEM_DETAIL_DELETE_ACTION";
export const VIN_WONDER_TICKET_ITEM_DETAIL_SUCCESS = "VIN_WONDER_TICKET_ITEM_DETAIL_SUCCESS";
export const VIN_WONDER_TICKET_ITEM_DETAIL_FAIL = "VIN_WONDER_TICKET_ITEM_DETAIL_FAIL"

export const VIN_WONDER_TICKET_ITEM_DETAIL_UPDATE_ACTION = "VIN_WONDER_TICKET_ITEM_DETAIL_UPDATE_ACTION";
export const VIN_WONDER_TICKET_ITEM_DETAIL_CREATE_ACTION = "VIN_WONDER_TICKET_ITEM_DETAIL_CREATE_ACTION";